import { HTMLAttributes, useState } from 'react';
import { Checkbox } from '@silvertours/front-shared';
import { DropdownWrapper } from './ProviderDropdown.styles';
import { Dropdown } from './Dropdown';

type ProviderDropdownProps = {
  value: string | null;
  label: string;
  onChange: (provider: string) => void;
} & Pick<HTMLAttributes<HTMLDivElement>, 'className'>;

const ProviderDropdown = ({
  value,
  label,
  onChange,
  className,
}: ProviderDropdownProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  return (
    <DropdownWrapper className={className}>
      {showDropdown ? (
        <Dropdown onChange={onChange} value={value || ''} />
      ) : (
        <Checkbox
          id="allProvider"
          label={label}
          checked
          onChange={() => setShowDropdown(!showDropdown)}
        />
      )}
    </DropdownWrapper>
  );
};

export { ProviderDropdown };
